<template>
  <section>
    <div class="row my-4 text-center" v-if="validate === 1">
      <div class="col-md-12">
        <h3>กดปุ่ม LINE ด้านล่างนี้เพื่อติดต่อเจ้าหน้าที่</h3>
        <template v-if="isLineUser">
          <a href="https://line.me/R/ti/p/%40beneatpro"
             class="btn btn-success btn-lg">
            <i class="fab fa-line fa-lg"></i>&nbsp;เชื่อมต่อกับ LINE
          </a>
          <div class="mt-4">
            <h4>ผู้สมัครได้เคยทำการเชื่อมต่อกับ LINE เรียบร้อยแล้วค่ะ</h4>
          </div>
        </template>
        <template v-else>
          <a :href="apiUrl"
             target="_blank"
             class="btn btn-success btn-lg"
             v-if="apiUrl">
            <i class="fab fa-line fa-lg"></i>&nbsp;เชื่อมต่อกับ LINE
          </a>
          <!-- <div class="mt-5">
            หมายเหตุ: หากลืมรหัสผ่าน สามารถกดที่ปุ่มตามรูปด้านล่างได้เลยค่ะ
          </div>
          <div>
            <img alt="Remark" style="width: 100%; max-width: 400px;" src="/static/img/provider-line01.jpg">
          </div> -->
        </template>
      </div>
    </div>
    <div class="row my-4 text-center" v-else-if="validate === 0">
      <div class="col-md-12">
        ระบบกำลังทำการตรวจสอบ กรุณารอสักครู่...
      </div>
    </div>
    <div class="row my-4 text-center" v-else>
      <div class="col-md-12 text-danger">
        เกิดข้อผิดพลาด กรุณาแจ้งแอดมินเพื่อทำการตรวจสอบค่ะ
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        queryData: {
          professional_register_id: null,
          validation: null
        },
        validate: 0,
        isLineUser: false,
        apiUrl: ''
      }
    },
    methods: {
      validateUser () {
        this.$http.get('line/validate-provider', { params: this.queryData })
          .then(response => {
            return response.json()
          })
          .then(response => {
            console.log(response)
            if (!response.error) {
              this.validate = 1
              this.isLineUser = Number(response.line_user) === 1
            } else {
              this.validate = 2
            }
          })
      }
    },
    created () {
      this.$store.commit('user/SET_NO_DATA')
      if (this.$route.query.professional_register_id) {
        this.queryData.professional_register_id = this.$route.query.professional_register_id
      }
      if (this.$route.query.validation) {
        this.queryData.validation = this.$route.query.validation
      }
      const code = Math.floor(Math.random() * 10000)
      const callback = encodeURIComponent(`https://beneat.co/line-provider/callback?professional_register_id=${this.queryData.professional_register_id}`)
      this.apiUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1653647212&redirect_uri=${callback}&code=${code}&state=${code}&scope=openid%20profile&bot_prompt=aggressive`
      this.validateUser()
    }
  }
</script>

<style scoped>
  .img-disabled {
      opacity: 0.5;
      filter: alpha(opacity=50);
  }
</style>



// WEBPACK FOOTER //
// src/components/information/LineProviderLogin.vue